import { fugModels } from "@/common/dict"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { Button, Form, Input, Select, Space } from "antd"
import { useEffect } from "react"
import { useOutletContext } from "react-router"

export function PropertySetBasic() {
  const {propertySet, onSave, onCancel} = useOutletContext<{propertySet: PropertySetModule.Modal, onSave: (values) => Promise<void>, onCancel: () => void}>();
  const [form] = Form.useForm()
  useEffect(() => {
    if (propertySet) {
      form.setFieldsValue({...propertySet})
    }
  }, [propertySet])
  const onFinished = async (values) => {
    await onSave({...values, components: []})
  }

  return <div>
    <Form
      form={form}
      onFinish={onFinished}
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter nozzle name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Equilibrium Model' name='fugModel' rules={[{ required: true, message: 'Please enter Equilibrium Model' }]}>
        <Select options={fugModels} style={{width: 200}} />
      </Form.Item>

      <div className="flex-end">
        <Space>
          <Button htmlType="button" type="default" onClick={onCancel}>Cancel</Button>
          <Button htmlType="submit" type="primary">Save</Button>
        </Space>
      </div>
    </Form>
  </div>
}